<mat-accordion *ngIf="(workflowHistory$ | async)">

  <mat-expansion-panel class="mt-4 mb-4 step-border"  *ngFor="let step of (workflowHistory$ | async)">
    <mat-expansion-panel-header >
      <mat-panel-title>{{step.workflowStepTitle}}</mat-panel-title>
    </mat-expansion-panel-header>

    <div *ngIf="step.form">
      <app-form-component [formData]="step.form" [readonly]="true"></app-form-component>
    </div>
  </mat-expansion-panel>

</mat-accordion>
